module.exports = __webpack_public_path__ + "static/media/rafa-prada-33648-unsplash.9a9a8005.jpg";